import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

function Floor1K6() {
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const imageRef = useRef(null);

  useEffect(() => {
    let stopTimeout;
    const startTimeout = setTimeout(() => {
      setIsHovered(true); // Show image briefly

      stopTimeout = setTimeout(() => {
        setIsHovered(false); // Hide it again
      }, 300); // duration the image is visible (1 second)
    }, 6500); // delay before showing the image

    return () => {
      clearTimeout(startTimeout);
      if (stopTimeout) clearTimeout(stopTimeout);
    };
  }, []);



  // Detect if screen size is small or medium (below 1024px)
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024); // `lg` breakpoint is 1024px
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Handle clicking outside the image to remove hover effect on mobile
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (imageRef.current && !imageRef.current.contains(event.target)) {
        setIsHovered(false);
        setIsClicked(false);
      }
    };

    if (isMobile && isClicked) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => document.removeEventListener("click", handleClickOutside);
  }, [isMobile, isClicked]);

  const handleClick = () => {
    if (isMobile) {
      if (!isClicked) {
        setIsHovered(true); // First click acts like hover
        setIsClicked(true);
      } else {
        navigate("/first-floor"); // Second click navigates
      }
    } else {
      navigate("/first-floor"); // On laptop, just navigate on click
    }
  };

  return (
    <>
      {/* Green Image (Hidden by Default, Appears on Hover or Click for Mobile) */}
      <img
        ref={imageRef}
        className={`absolute w-[26.2vw] right-[13.9vw] top-[38.55vw] cursor-pointer transition-opacity duration-300 ${isHovered ? "opacity-100" : "opacity-0"
          }`}
        src="/images/click/clickable-images/Floors/Floor1-K6-Green.png"
        alt=""
        onMouseEnter={() => !isMobile && setIsHovered(true)} // Hover effect for laptop
        onMouseLeave={() => !isMobile && setIsHovered(false)} // Only reset hover on laptop
        onClick={handleClick} // Click-to-hover for mobile
      />

      {/* Tooltip on Hover or Click (for Mobile) */}
      {isHovered && (
        <span className="absolute right-[7.5vw] top-[39vw] bg-[#192929] montserrat font-medium text-white text-xs md:text-base px-2 lg:px-4 py-2 lg:py-3 shadow-md">
          Kati 1
        </span>
      )}
    </>
  );
}

export default Floor1K6;
